import { render, staticRenderFns } from "./tableSocialAttendance.vue?vue&type=template&id=42270576&"
import script from "./tableSocialAttendance.js?vue&type=script&lang=js&"
export * from "./tableSocialAttendance.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports